// Backdrop.js
import React from "react";
import { Box } from "@mui/material";

const Backdrop = ({ onClick }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        zIndex: 999, // Debe estar por debajo del contenido del SwipeBottom
        cursor: "pointer",
      }}
      onClick={onClick} // Al hacer clic en el backdrop, se cerrará el SwipeBottom
    />
  );
};

export default Backdrop;
